export const homeEs = {
  mainbannerHome: {
    title:
      "Convertimos IA y tecnología en ventajas competitivas para tu empresa",
    subtitle:
      "Integramos  innovación, método y talento para que tus equipos adopten y escalen con fluidez.",
  },
  trusted: {
    whoTrustUs: "Confían en nosotros",
  },
  menuServices: {
    title: "Soluciones",
    subtitle1: "Potencie su negocio con nuestras soluciones",
    subtitle2: "nuestras soluciones",
    digitalProductSubtitle: "Convertimos IA y datos en casos concretos de negocio",
    digitalProductPart1: "IA & Datos",
    digitalProductPart2: "",
    cloudAndDevOpsSubtitle: "Reducimos tu exposición para que ganes más control en el día a día",
    cloudAndDevOpsPart1: "Seguridad",
    cloudAndDevOpsPart2: "",
    dataScienceSubtitle: "Aceleramos el desarrollo de nuestros equipos full code ó low code con agentes",
    dataSciencePart1: "Ingeniería de Software",
    dataSciencePart2: "aumentada con IA",
    aiEngineeringSubtitle: "Optimizamos tu infraestructura con soluciones cloud seguras y gestión confiable de IT",
    aiEngineeringPart1: "Cloud & Ingeniería",
    aiEngineeringPart2: "de Plataformas",
    button: "Saber más",
    sre: "Cloud Engineering & DevOps Practice",
    staffPart1: "Staff",
    staffPart2: "Augmentation",
    staffPart1MenuHeader: "Staff augmentation",
    buttonSend: "Enviar",
  },
  whatWeDo: {
    topTitle: "Soluciones",
    title1: "Ingeniería de productos digitales",
    description1:
      "Transformamos tus ideas en experiencias digitales excepcionales con soluciones tecnológicas adaptadas a tus objetivos",
  },
  bannerDownloadFree: {
    title: "Descargue gratis nuestro brochure",
  },
  msSeparator: {
    title: `Somos Top partners
    de Microsoft en Argentina`,
  },
  awards: {
    title: "Premios",
    description: "Reconocimientos que  avalan nuestra calidad y el compromiso de acompañar hasta que el cambio suceda.",
    button: "Lo que dicen nuestros clientes",
  },
  page404: {
    title: "Algo ha desaparecido...",
    paragrahp:
      "Lo sentimos, el contenido que busca no existe. O bien ha sido eliminado, o ha escrito mal el enlace.",
    button: "Ir al Home",
  },
};

export const homeEn = {
  mainbannerHome: {
    title: "{{title}}",
    subtitle: "{{subtitle}}",
    services: "{{servicesHome}}",
  },
  trusted: {
    whoTrustUs: "{{whoTrustUs}}",
  },
  menuServices: {
    title: "{{title}}",
    subtitle1: "{{subtitle1}}",
    subtitle2: "{{subtitle2}}",
    softPart1: "{{softPart1}}",
    softPart2: "{{softPart2}}",
    button: "{{button}}",
    sre: "{{sre}}",
    staffPart1: "{{staffPart1}}",
    staffPart2: "{{staffPart2}}",
    staffPart1MenuHeader: "{{staffPart1MenuHeader}}",
    digitalProductSubtitle: "{{digitalProductSubtitle}}",
    digitalProductPart1: "{{digitalProductPart1}}",
    digitalProductPart2: "{{digitalProductPart2}}",
    cloudAndDevOpsSubtitle: "{{cloudAndDevOpsSubtitle}}",
    cloudAndDevOpsPart1: "{{cloudAndDevOpsPart1}}",
    cloudAndDevOpsPart2: "{{cloudAndDevOpsPart2}}",
    dataScienceSubtitle: "{{dataScienceSubtitle}}",
    dataSciencePart1: "{{dataSciencePart1}}",
    dataSciencePart2: "{{dataSciencePart2}}",
    aiEngineeringSubtitle: "{{aiEngineeringSubtitle}}",
    aiEngineeringPart1: "{{aiEngineeringPart1}}",
    aiEngineeringPart2: "{{aiEngineeringPart2}}",
    buttonSend: "{{buttonSend}}",
  },
  bannerDownloadFree: {
    title: "{{bannerDownloadFree}}",
  },
  awards: {
    title: "{{title}}",
    description: "{{description}}",
    button: "{{button}}",
  },
  page404: {
    title: "{{title}}",
    paragrahp: "{{paragrahp}}",
    button: "{{button}}",
  },
};
